export enum NomenclaturesValuesEnum {
  QUALITE_REPRESENTANT_LEGAL = 'QUALITE_REPRESENTANT_LEGAL',
  AUTHOR_SPECIALITY = 'AUTHOR_SPECIALITY',
  CLASS_CODE = 'CLASS_CODE',
  CONFIDENTIALITY_CODE = 'CONFIDENTIALITY_CODE',
  CONTENT_TYPE_CODE = 'CONTENT_TYPE_CODE',
  FORMAT_CODE = 'FORMAT_CODE',
  HEALTH_CARE_FACILITY_TYPE_CODE = 'HEALTH_CARE_FACILITY_TYPE_CODE',
  PRACTICE_SETTING_CODE = 'PRACTICE_SETTING_CODE',
  SUBJECT_ROLE = 'SUBJECT_ROLE',
  TYPE_CODE = 'TYPE_CODE',
  RESTRICTION_AUDIENCE_VIHF = 'RESTRICTION_AUDIENCE_VIHF',
  UNKNOWN = 'UNKNOWN',
  ACT_SUBSTANCE_ADMINISTRATION_IMMUNIZATION = 'ACT_SUBSTANCE_ADMINISTRATION_IMMUNIZATION',
  IMMUNIZATION_APPROACH_SITE = 'IMMUNIZATION_APPROACH_SITE',
  IMMUNIZATION_ROUTE = 'IMMUNIZATION_ROUTE',
}


export enum EntityNameEnum {
  PATIENT = 'patient',
  APPOINTMENT = 'appointment',
  VISIT = 'visit',
  MEDICAL_ORDER = 'medicalOrder',
  ORDER = 'order',
}